import { CommonModule } from '@angular/common';
import {
  Component,
  VERSION,
  ViewChild,
  OnInit,
  ElementRef,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Output,
  EventEmitter
} from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { PlatformApiWpService } from 'src/app/services/platform-apiwp.service';

declare var MediaRecorder: any;


@Component({
  standalone: true,
  imports: [
    CommonModule
  ],
  selector: 'app-video-recorder-old',
  templateUrl: './video-recorder-old.component.html',
  styleUrls: ['./video-recorder-old.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class VideoRecorderOldComponent implements OnInit {
  @ViewChild('recordedVideo') recordVideoElementRef!: ElementRef;
  @ViewChild('video') videoElementRef!: ElementRef;

  videoElement!: HTMLVideoElement;
  recordVideoElement!: HTMLVideoElement;
  mediaRecorder: any;
  recordedBlobs: Blob[] = [];
  isRecording: boolean = false;
  downloadUrl: string | null = null;
  stream!: MediaStream;
  videoCapabilities!: MediaTrackCapabilities;

  @Output() stopRecordingEmitter = new EventEmitter<{ blob: Blob, url: string }>();
  @Output() dataAvailable = new EventEmitter<Blob[]>();
  videoBlob!: Blob;
  recordingTimeout!: any;
  max_video_duration!: number;
  isVideoDurationValid: boolean = false;

  constructor(
    private cdr: ChangeDetectorRef,
    private platformApiWpService: PlatformApiWpService,
  ) { }

  ngOnInit() {
    console.log('ngOnInit VideoRecorderComponent');
  }
  
  startVideoRecording() {
    this._ngOnInit();
  }

  async _ngOnInit() {

    // let data = {
    //   video: {
    //     width: 360,
    //     facingMode: { exact: 'environment' }
    //   },
    //   audio: true
    // }
    let data: any = {
      video: {
      },
      audio: true
    }

    if (this.checkIsMobile()) {
      data.video.facingMode = { exact: 'environment' }
    }

    navigator.mediaDevices
      .getUserMedia(data)
      .then(stream => {
        this.videoElement = this.videoElementRef.nativeElement;
        // this.recordVideoElement = this.recordVideoElementRef.nativeElement;

        this.stream = stream;
        this.videoElement.srcObject = this.stream;

        const videoTrack = this.stream.getVideoTracks()[0];
        this.videoCapabilities = videoTrack.getCapabilities();

        console.log('Video Capabilities:', this.videoCapabilities);

        if (this.videoCapabilities) {
          if (this.videoCapabilities.width && this.videoCapabilities.height) {
            videoTrack.applyConstraints({
              width: this.videoCapabilities.width.max,
              height: this.videoCapabilities.height.max
            });
          }
          if (this.videoCapabilities.facingMode && this.videoCapabilities.facingMode.indexOf('environment') > -1) {
            videoTrack.applyConstraints({
              facingMode: 'environment'
            });
          }
        }


      }).catch((err) => {
        if (err && err.message.indexOf('Permission denied') > -1) {
          alert('Attenzione... è necessario concedere i permessi');
        }
        console.log('Devono essere concessi i permessi per la fotocamera')
      })
  }

  checkIsMobile() {
    var ua = navigator.userAgent;

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua))
      return true;
    // else if(/Chrome/i.test(ua))
    //    $('a.chrome').show();

    // else
    //    $('a.desktop-other').show();
    return false;
  }

  startRecording() {
    this.recordedBlobs = [];
    this.downloadUrl = null;
    this.cdr.detectChanges();
    let options: any = { mimeType: 'video/webm' };

    try {
      this.mediaRecorder = new MediaRecorder(this.stream, options);
    } catch (err) {
      console.log(err);
    }

    this.mediaRecorder.start(); // collect 100ms of data
    this.recordingTimeout = setTimeout(() => {
      if (this.mediaRecorder.state === 'recording') {
        this.stopRecording();
      }
    }, 120000); // Stop recording after 2 minutes
    this.isRecording = !this.isRecording;
    this.attachEvents();
    // this.onDataAvailableEvent();
    // this.onStopRecordingEvent();
  }

  stopRecording() {
    this.mediaRecorder.stop();
    if (this.recordingTimeout) {
      clearTimeout(this.recordingTimeout);
    }
    this.isRecording = !this.isRecording;
    console.log('Recorded Blobs: ', this.recordedBlobs);

  }

  playRecording() {
    if (!this.recordedBlobs || !this.recordedBlobs.length) {
      console.log('cannot play.');
      return;
    }
    if (!this.recordVideoElement && this.recordVideoElementRef) {
      this.recordVideoElement = this.recordVideoElementRef.nativeElement
    }
    this.recordVideoElement.play();
  }

  attachEvents(){
    this.onDataAvailableEvent();
    this.onStopRecordingEvent();
    this.mediaRecorder.onerror = (err: any) => {
      console.log(err);
    }
    this.mediaRecorder.onstart = (event: any) => {
      console.log('MediaRecorder started:', event);
    };
  }

  onDataAvailableHandler(event: any) {
    if (event.data && event.data.size > 0) {
      this.recordedBlobs.push(event.data);
      this.dataAvailable.emit(this.recordedBlobs);
    }
  };

  onDataAvailableEvent() {
    try {
      this.mediaRecorder.ondataavailable = this.onDataAvailableHandler.bind(this);
    } catch (error) {
      console.log(error);
    }
  }

  onStopHandler(event: Event) {
    const videoBuffer = new Blob(this.recordedBlobs, {
      type: 'video/webm'
    });
    this.downloadUrl = window.URL.createObjectURL(videoBuffer); // you can download with <a> tag
    this.cdr.detectChanges();
    // this.recordVideoElement.src = this.downloadUrl;
    this.videoBlob = videoBuffer;
    this.stopRecordingEmitter.emit({ 'blob': this.videoBlob, 'url': this.downloadUrl }) // this.videoBlob, this.downloadUrl);

    this.checkVideoDuration();
  };

  onStopRecordingEvent() {
    try {
      this.mediaRecorder.onstop = this.onStopHandler.bind(this);
    } catch (error) {
      console.log(error);
    }
  }

  checkVideoDuration() {
    if (this.downloadUrl) {
      this.isVideoDurationValid = false;
      const videoElement = document.createElement('video');
      videoElement.src = this.downloadUrl;
      videoElement.addEventListener('loadedmetadata', () => {
        console.log('Video duration:', videoElement.duration);
        if (videoElement.duration > this.max_video_duration) {
          this.isVideoDurationValid = false;
          return;
        } else {
          this.isVideoDurationValid = true;
        }
      });
    }
  }

  async uploadVideo() {
    if (!this.videoBlob) {
      console.error('No video recorded.');
      return;
    }

    if (!this.isVideoDurationValid) {
      console.error('Video duration is not valid.');
      return;
    }

    const formData = new FormData();
    formData.append('file', this.videoBlob, 'video.mp4');

    this.platformApiWpService.postFileRequest('playmetrics/v1/upload_video', formData)
      .then((sub) => {
        sub
          .pipe(
            catchError((err) => {
              console.log(err);
              return throwError(() => err);
            })
          )
          .subscribe((response: any) => {
            console.log(response);
            if (response && response.status == 'ok' && response.payload && response.payload.attachment_id) {
              this.platformApiWpService.postFileRequest('playmetrics/v1/start', {
                'attachment_id': response.payload.attachment_id,
                'video_description': 'descrizione di test',
              }).then((sub) => {
                sub
                  .pipe(
                    catchError((err) => {
                      console.log(err);
                      return throwError(() => err);
                    })
                  )
                  .subscribe((response: any) => {
                    console.log(response);
        
                  })
              });
            }


          })
      })
  }

}
